import Vue from 'vue'

const cluesAdd = {
  namespaced: true,
  state: {
    metadata: {},
    cut: false
  },
  getters: {},
  mutations: {
    UPDATE_META_DATA (state, data) {
      if (typeof data === 'object') {
        Object.keys(data).forEach((item) => {
          Vue.set(state.metadata, item, data[item])
        })
      }
    },
    UPDATE_CUT_DATA (state, data) {
      state.cut = data
    }
  },
  actions: {
    FETCH_META_DATA ({commit}, params) {
      commit('UPDATE_META_DATA', params)
    },
    UPDATE_CUT_DATA ({commit}, params) {
      commit('UPDATE_CUT_DATA', params)
    }
  }
}

export default cluesAdd
